var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SalesRepDataActionType } from "./actionTypes";
import store from "../../reduxStore/store";
import { getViewCouponDataService, salesRepBaseDataService, salesRepOrdersDataService, createCouponService, removeCouponService, addCustomerDataService, singleCustomerDataService, orderCountDetailsService, orderWiseProductsDataService, customerAddressDataService, productRenderDataService, createDraftOrderService, draftOrderDataService, draftOrderDetailsService, duplicateOrderService, sendInvoiceDataService, deleteInvoiceService, refundOrderDataService, deleteShareCartLinkService, createCartService, uploadAffiliateLinkData, uploadAffiliatePhoto, GetAllWholesalePriceService, DataAddOnCart, forgotPasswordService, userLoginService, submitSignupRepDetailsService, updatePasswordService, GetCartData, affiliateLinkConfirmationService, GetCompanyLocationPricelistService, createB2bDraftOrderService, updateB2bDraftOrderService, GetCompanyLocationSearchedPricelistService, GetCompanyLocationQuantityRuleService, B2BCreateCompanyGetService, B2BCreateUpdateCompanyPostService, removeProfileImageService, getAllCustomersService, GetProductDataService, getB2BCompaniesService, getB2BCompanyByIdService, beginStReportsDataRequest, isStReportsRequestAborted, stReportsDataService, stReportsCSVService, displaySnackbarErrMsg, } from "../../services/apiServices/salesRepDataService";
import { logClientRuntimeError } from "../../services/clientErrorLog";
import { cloneSTOrderDetailsReportsPayload, getSTOrderDetailsDefaultDateRangeApiKeys, getSTOrderDetailsTabSlicesFromPayload, matchesSTOrderDetailsDefaultBootstrapRequest, mergeStReportsOrdersApiPayload, prepareSTOrderDetailsReportsPayload, ST_ORDER_DETAILS_DEFAULT_ROWS_PER_PAGE, } from "../../component/model/STOrderDetailsModel";
import { buildSTReportsOrdersCacheRangeKey, getSTReportsDisplayPayloadFromCache, hasSTReportsExactRangeCacheAuthority, } from "../stReportsOrdersCache";
import { seedSTOrderDetailsPresetCachesFromThirtyDayBootstrap } from "../stOrderDetailsPresetCache";
import { COLLECTION_IDS_CHUNK_SIZE, COLLECTION_PAGINATION_CONCURRENCY } from "../../component/Constant";
// Action will call api service for data="1"
export var fetchRemainingPagesForCollection = function (productSearchText, storefrontAccessToken, mergeProducts, collectionId, startCursor) { return __awaiter(void 0, void 0, void 0, function () {
    var cursor, result, nextPageInfo;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!startCursor)
                    return [2 /*return*/];
                cursor = startCursor;
                _a.label = 1;
            case 1:
                if (!(cursor !== undefined)) return [3 /*break*/, 3];
                return [4 /*yield*/, GetProductDataService(productSearchText, storefrontAccessToken, cursor, undefined, collectionId)];
            case 2:
                result = _a.sent();
                mergeProducts(result.products);
                nextPageInfo = result.pageInfo;
                cursor = (nextPageInfo === null || nextPageInfo === void 0 ? void 0 : nextPageInfo.hasNextPage) ? nextPageInfo.endCursor : undefined;
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchAllProductsForCollections = function (collectionIds, productSearchText, storefrontAccessToken) { return __awaiter(void 0, void 0, void 0, function () {
    var allProducts, productIdSet, mergeProducts, chunkCount, chunkResults, collectionsWithNextPage, _i, chunkResults_1, result, products, collectionPageInfoMap, _a, collectionPageInfoMap_1, c, i, batch;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (collectionIds.length === 0)
                    return [2 /*return*/, []];
                allProducts = [];
                productIdSet = new Set();
                mergeProducts = function (products) {
                    if (!(products === null || products === void 0 ? void 0 : products.length))
                        return;
                    for (var _i = 0, products_1 = products; _i < products_1.length; _i++) {
                        var product = products_1[_i];
                        if (!productIdSet.has(product.productId)) {
                            productIdSet.add(product.productId);
                            allProducts.push(product);
                        }
                    }
                };
                chunkCount = Math.ceil(collectionIds.length / COLLECTION_IDS_CHUNK_SIZE);
                return [4 /*yield*/, Promise.all(Array.from({ length: chunkCount }, function (_, i) {
                        return GetProductDataService(productSearchText, storefrontAccessToken, undefined, undefined, undefined, undefined, collectionIds.slice(i * COLLECTION_IDS_CHUNK_SIZE, (i + 1) * COLLECTION_IDS_CHUNK_SIZE));
                    }))];
            case 1:
                chunkResults = _c.sent();
                collectionsWithNextPage = [];
                for (_i = 0, chunkResults_1 = chunkResults; _i < chunkResults_1.length; _i++) {
                    result = chunkResults_1[_i];
                    products = result.products, collectionPageInfoMap = result.collectionPageInfoMap;
                    mergeProducts(products);
                    if ((collectionPageInfoMap === null || collectionPageInfoMap === void 0 ? void 0 : collectionPageInfoMap.length) > 0) {
                        for (_a = 0, collectionPageInfoMap_1 = collectionPageInfoMap; _a < collectionPageInfoMap_1.length; _a++) {
                            c = collectionPageInfoMap_1[_a];
                            if ((_b = c.pageInfo) === null || _b === void 0 ? void 0 : _b.hasNextPage)
                                collectionsWithNextPage.push(c);
                        }
                    }
                }
                i = 0;
                _c.label = 2;
            case 2:
                if (!(i < collectionsWithNextPage.length)) return [3 /*break*/, 5];
                batch = collectionsWithNextPage.slice(i, i + COLLECTION_PAGINATION_CONCURRENCY);
                return [4 /*yield*/, Promise.all(batch.map(function (c) { return fetchRemainingPagesForCollection(productSearchText, storefrontAccessToken, mergeProducts, c.collectionId, c.pageInfo.endCursor); }))];
            case 3:
                _c.sent();
                _c.label = 4;
            case 4:
                i += COLLECTION_PAGINATION_CONCURRENCY;
                return [3 /*break*/, 2];
            case 5: return [2 /*return*/, allProducts];
        }
    });
}); };
export function getSalesRepBaseData() {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var salesRepData, action;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, salesRepBaseDataService().then(function (data) { return data; })];
                case 1:
                    salesRepData = _a.sent();
                    if (salesRepData) {
                        action = {
                            payload: salesRepData,
                            type: SalesRepDataActionType.BASE_DATA,
                        };
                        return [2 /*return*/, dispatch(action)];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
}
export function getSalesRepOrders() {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var salesRepOrdersData, action, action;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, salesRepOrdersDataService().then(function (data) { return data; })];
                case 1:
                    salesRepOrdersData = _d.sent();
                    if (salesRepOrdersData) {
                        action = {
                            payload: __assign(__assign(__assign({}, (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.ordersData), salesRepOrdersData), { refundOrdersDetails: refundOrdersFilters((_b = salesRepOrdersData === null || salesRepOrdersData === void 0 ? void 0 : salesRepOrdersData.allRefundOrdersDetails) !== null && _b !== void 0 ? _b : []), isPaidUnPaidOrdersLoaded: true, ordersData: {
                                    AllOrdersCommission: updateKeysOfArray((salesRepOrdersData === null || salesRepOrdersData === void 0 ? void 0 : salesRepOrdersData.AllOrdersCommission) || []),
                                    allRefundOrdersDetails: updateKeysOfArray((salesRepOrdersData === null || salesRepOrdersData === void 0 ? void 0 : salesRepOrdersData.allRefundOrdersDetails) || []),
                                    draftOrdersDetails: updateKeysOfArray((salesRepOrdersData === null || salesRepOrdersData === void 0 ? void 0 : salesRepOrdersData.draftOrdersDetails) || []),
                                } }),
                            type: SalesRepDataActionType.ORDERS_DATA,
                        };
                        return [2 /*return*/, dispatch(action)];
                    }
                    else {
                        action = {
                            payload: __assign(__assign({}, (_c = store.getState().salesRepData) === null || _c === void 0 ? void 0 : _c.ordersData), { refundOrdersDetails: [], isPaidUnPaidOrdersLoaded: false }),
                            type: SalesRepDataActionType.ORDERS_DATA,
                        };
                        return [2 /*return*/, dispatch(action)];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
}
function writeStReportsOrdersCacheEntry(dispatch, request, apiPayload) {
    var _a, _b, _c, _d, _e;
    var dateFrom = String((_a = request.dateFrom) !== null && _a !== void 0 ? _a : "").trim();
    var dateTo = String((_b = request.dateTo) !== null && _b !== void 0 ? _b : "").trim();
    var pageSize = Number(request.pageSize);
    if (!dateFrom || !dateTo || !Number.isFinite(pageSize) || pageSize <= 0) {
        return;
    }
    var tab = String((_c = request.activeTab) !== null && _c !== void 0 ? _c : "All").trim() || "All";
    var pageNumber = Number(request.pageNumber) > 0 ? Number(request.pageNumber) : 1;
    var searchQuery = String((_d = request.searchQuery) !== null && _d !== void 0 ? _d : "").trim();
    var rangeKey = buildSTReportsOrdersCacheRangeKey(dateFrom, dateTo, pageSize, searchQuery);
    var finalized = (_e = prepareSTOrderDetailsReportsPayload(apiPayload)) !== null && _e !== void 0 ? _e : apiPayload;
    dispatch({
        type: SalesRepDataActionType.ST_REPORTS_ORDERS_CACHE,
        payload: {
            rangeKey: rangeKey,
            tab: tab,
            pageNumber: pageNumber,
            pageSize: pageSize,
            searchQuery: searchQuery,
            apiPayload: finalized,
        },
    });
}
/** Apply Case 59 grid data from Redux `ordersByDateRange` cache (no API). */
export function applyStReportsFromOrdersCache(dispatch, params) {
    var _a;
    var rangeKey = buildSTReportsOrdersCacheRangeKey(params.dateFrom, params.dateTo, params.pageSize, params.searchQuery);
    var cache = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.stReportsOrdersByDateRange;
    if (!hasSTReportsExactRangeCacheAuthority(cache, rangeKey, params.pageSize)) {
        return false;
    }
    var displayPayload = getSTReportsDisplayPayloadFromCache(cache, rangeKey, params.tab, params.pageNumber, params.pageSize);
    if (displayPayload == null) {
        return false;
    }
    dispatch({
        payload: displayPayload,
        type: SalesRepDataActionType.ST_REPORTS_DATA,
    });
    return true;
}
/** Comparable `All` tab order count from a Case 59 payload (for 30-day bootstrap refresh). */
function getSTReportsThirtyDayAllOrderCount(payload) {
    var _a, _b;
    var prepared = prepareSTOrderDetailsReportsPayload(payload);
    if (!prepared) {
        return 0;
    }
    var slices = getSTOrderDetailsTabSlicesFromPayload(prepared);
    if (slices) {
        var total = Number((_a = slices.all.totalCount) !== null && _a !== void 0 ? _a : 0);
        if (Number.isFinite(total) && total > 0) {
            return total;
        }
        return Array.isArray(slices.all.orders) ? slices.all.orders.length : 0;
    }
    var raw = (_b = prepared.totalCount) !== null && _b !== void 0 ? _b : prepared.TotalCount;
    var n = Number(raw);
    return Number.isFinite(n) && n >= 0 ? n : 0;
}
function getThirtyDayBootstrapOrderCountFromState() {
    var _a, _b, _c, _d;
    var _e = getSTOrderDetailsDefaultDateRangeApiKeys(), dateFrom = _e.dateFrom, dateTo = _e.dateTo;
    var best = getSTReportsThirtyDayAllOrderCount((_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.stReportsDefaultData);
    var cache = (_c = (_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.stReportsOrdersByDateRange) !== null && _c !== void 0 ? _c : {};
    for (var _i = 0, _f = Object.keys(cache); _i < _f.length; _i++) {
        var key = _f[_i];
        if (!key.startsWith("".concat(dateFrom, "|").concat(dateTo, "|")) || key.includes("|q:")) {
            continue;
        }
        var count = getSTReportsThirtyDayAllOrderCount((_d = cache[key]) === null || _d === void 0 ? void 0 : _d.mergedPayload);
        if (count > best) {
            best = count;
        }
    }
    return best;
}
function syncStReportsThirtyDayDefaultFromCache(dispatch, dateFrom, dateTo, pageSize, searchQuery) {
    var _a, _b, _c, _d;
    if (searchQuery.trim().length > 0) {
        return;
    }
    var bootstrap = getSTOrderDetailsDefaultDateRangeApiKeys();
    if (dateFrom !== bootstrap.dateFrom || dateTo !== bootstrap.dateTo) {
        return;
    }
    var rangeKey = buildSTReportsOrdersCacheRangeKey(dateFrom, dateTo, pageSize, searchQuery);
    var merged = (_c = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.stReportsOrdersByDateRange) === null || _b === void 0 ? void 0 : _b[rangeKey]) === null || _c === void 0 ? void 0 : _c.mergedPayload;
    var source = merged !== null && merged !== void 0 ? merged : (_d = store.getState().salesRepData) === null || _d === void 0 ? void 0 : _d.stReportsDefaultData;
    if (source == null) {
        return;
    }
    dispatch({
        payload: cloneSTOrderDetailsReportsPayload(source),
        type: SalesRepDataActionType.ST_REPORTS_DEFAULT_DATA,
    });
}
export function getSalesRepSTReports(request) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var dateFrom, dateTo, pageSize, pageNumber, tab, searchQuery, isSearchMode, refreshThirtyDayCacheOnly, skipOrdersCache, preservePreviousPayload, previousPayload, fetchSignal, stReportsData, payload, error_1;
        var _a, _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    dateFrom = String((_a = request.dateFrom) !== null && _a !== void 0 ? _a : "").trim();
                    dateTo = String((_b = request.dateTo) !== null && _b !== void 0 ? _b : "").trim();
                    pageSize = Number(request.pageSize);
                    pageNumber = Number(request.pageNumber) > 0 ? Number(request.pageNumber) : 1;
                    tab = String((_c = request.activeTab) !== null && _c !== void 0 ? _c : "All").trim() || "All";
                    searchQuery = String((_d = request.searchQuery) !== null && _d !== void 0 ? _d : "").trim();
                    isSearchMode = searchQuery.length > 0;
                    refreshThirtyDayCacheOnly = request.refreshThirtyDayCacheOnly === true;
                    skipOrdersCache = request.skipOrdersCache === true || refreshThirtyDayCacheOnly;
                    if (!skipOrdersCache && dateFrom && dateTo && Number.isFinite(pageSize) && pageSize > 0) {
                        if (applyStReportsFromOrdersCache(dispatch, {
                            dateFrom: dateFrom,
                            dateTo: dateTo,
                            pageSize: pageSize,
                            tab: tab,
                            pageNumber: pageNumber,
                            searchQuery: searchQuery,
                        })) {
                            return [2 /*return*/, (_e = store.getState().salesRepData) === null || _e === void 0 ? void 0 : _e.stReportsData];
                        }
                    }
                    preservePreviousPayload = request.preservePreviousPayload === true;
                    previousPayload = refreshThirtyDayCacheOnly
                        ? null
                        : (_f = store.getState().salesRepData) === null || _f === void 0 ? void 0 : _f.stReportsData;
                    if (!preservePreviousPayload && !refreshThirtyDayCacheOnly) {
                        dispatch({
                            payload: null,
                            type: SalesRepDataActionType.ST_REPORTS_DATA,
                        });
                    }
                    fetchSignal = beginStReportsDataRequest();
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, stReportsDataService(request, { signal: fetchSignal })];
                case 2:
                    stReportsData = _h.sent();
                    payload = prepareSTOrderDetailsReportsPayload(stReportsData);
                    /** Only merge while paginating within the same range; never blend empty API rows with a prior range. */
                    if (payload && previousPayload && !isSearchMode && !refreshThirtyDayCacheOnly && preservePreviousPayload) {
                        payload = mergeStReportsOrdersApiPayload(previousPayload, payload, tab, { isSearchMode: false });
                    }
                    if (payload) {
                        payload = cloneSTOrderDetailsReportsPayload(payload);
                    }
                    if (!refreshThirtyDayCacheOnly) {
                        dispatch({
                            payload: payload,
                            type: SalesRepDataActionType.ST_REPORTS_DATA,
                        });
                    }
                    if (payload && request.skipOrdersCacheWrite !== true) {
                        writeStReportsOrdersCacheEntry(dispatch, request, payload);
                        syncStReportsThirtyDayDefaultFromCache(dispatch, dateFrom, dateTo, pageSize, searchQuery);
                        if (matchesSTOrderDetailsDefaultBootstrapRequest(request)) {
                            seedSTOrderDetailsPresetCachesFromThirtyDayBootstrap(dispatch, payload, pageSize);
                        }
                    }
                    if (payload &&
                        matchesSTOrderDetailsDefaultBootstrapRequest(request) &&
                        (refreshThirtyDayCacheOnly || !((_g = store.getState().salesRepData) === null || _g === void 0 ? void 0 : _g.stReportsDefaultData))) {
                        dispatch({
                            payload: cloneSTOrderDetailsReportsPayload(payload),
                            type: SalesRepDataActionType.ST_REPORTS_DEFAULT_DATA,
                        });
                    }
                    return [2 /*return*/, payload !== null && payload !== void 0 ? payload : false];
                case 3:
                    error_1 = _h.sent();
                    if (isStReportsRequestAborted(error_1)) {
                        return [2 /*return*/, false];
                    }
                    logClientRuntimeError("getSalesRepSTReports", error_1);
                    if (!refreshThirtyDayCacheOnly) {
                        dispatch({
                            payload: null,
                            type: SalesRepDataActionType.ST_REPORTS_DATA,
                        });
                        displaySnackbarErrMsg();
                    }
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
/**
 * Refreshes last-30-days Redux data after leaving Sales Order Details (non-blocking).
 * When the refreshed 30-day `All` count increases, clears per-date-range cache so stale preset/range entries are dropped.
 */
export function refreshStReportsThirtyDayCacheInBackground() {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var _a, dateFrom, dateTo, pageSize, priorCount, refreshed, newCount, defaultData, finalized, error_2;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _a = getSTOrderDetailsDefaultDateRangeApiKeys(), dateFrom = _a.dateFrom, dateTo = _a.dateTo;
                    pageSize = ST_ORDER_DETAILS_DEFAULT_ROWS_PER_PAGE;
                    priorCount = getThirtyDayBootstrapOrderCountFromState();
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch(getSalesRepSTReports({
                            dateFrom: dateFrom,
                            dateTo: dateTo,
                            pageSize: pageSize,
                            activeTab: "All",
                            pageNumber: 1,
                            skipOrdersCache: true,
                            refreshThirtyDayCacheOnly: true,
                        }))];
                case 2:
                    refreshed = _e.sent();
                    newCount = refreshed && typeof refreshed === "object"
                        ? getSTReportsThirtyDayAllOrderCount(refreshed)
                        : getSTReportsThirtyDayAllOrderCount((_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.stReportsDefaultData);
                    if (newCount > priorCount) {
                        dispatch({
                            type: SalesRepDataActionType.ST_REPORTS_CLEAR_ORDERS_CACHE,
                        });
                        defaultData = (_c = store.getState().salesRepData) === null || _c === void 0 ? void 0 : _c.stReportsDefaultData;
                        if (defaultData != null) {
                            finalized = (_d = prepareSTOrderDetailsReportsPayload(defaultData)) !== null && _d !== void 0 ? _d : defaultData;
                            writeStReportsOrdersCacheEntry(dispatch, {
                                dateFrom: dateFrom,
                                dateTo: dateTo,
                                pageSize: pageSize,
                                activeTab: "All",
                                pageNumber: 1,
                            }, finalized);
                            seedSTOrderDetailsPresetCachesFromThirtyDayBootstrap(dispatch, finalized, pageSize);
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _e.sent();
                    logClientRuntimeError("refreshStReportsThirtyDayCacheInBackground", error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
/** Restore working Case 59 grid data from Redux date-range cache or default bootstrap (no API). */
export function restoreStReportsFromDefault() {
    return function (dispatch) {
        var _a, _b, _c;
        var _d = getSTOrderDetailsDefaultDateRangeApiKeys(), dateFrom = _d.dateFrom, dateTo = _d.dateTo;
        var pageSize = ST_ORDER_DETAILS_DEFAULT_ROWS_PER_PAGE;
        var rangeKey = buildSTReportsOrdersCacheRangeKey(dateFrom, dateTo, pageSize);
        var cache = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.stReportsOrdersByDateRange;
        var fromCache = getSTReportsDisplayPayloadFromCache(cache, rangeKey, "All", 1, pageSize);
        if (fromCache) {
            dispatch({
                payload: fromCache,
                type: SalesRepDataActionType.ST_REPORTS_DATA,
            });
            return;
        }
        var defaultData = (_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.stReportsDefaultData;
        if (defaultData == null) {
            return;
        }
        var finalized = (_c = prepareSTOrderDetailsReportsPayload(defaultData)) !== null && _c !== void 0 ? _c : defaultData;
        var cloned = cloneSTOrderDetailsReportsPayload(finalized);
        dispatch({
            payload: cloned,
            type: SalesRepDataActionType.ST_REPORTS_DATA,
        });
        writeStReportsOrdersCacheEntry(dispatch, {
            dateFrom: dateFrom,
            dateTo: dateTo,
            pageSize: pageSize,
            activeTab: "All",
            pageNumber: 1,
        }, finalized);
    };
}
export function downloadSTReportsCSV(request) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var blob, error_3, url, link, df, dt;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    blob = false;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, stReportsCSVService(__assign(__assign({}, request), { exportCsv: true }))];
                case 2:
                    blob = _c.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _c.sent();
                    logClientRuntimeError("downloadSTReportsCSV", error_3);
                    displaySnackbarErrMsg();
                    return [2 /*return*/, false];
                case 4:
                    if (!blob) {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    url = window.URL.createObjectURL(blob);
                    link = document.createElement("a");
                    link.href = url;
                    df = (_a = request.dateFrom) !== null && _a !== void 0 ? _a : "report";
                    dt = (_b = request.dateTo) !== null && _b !== void 0 ? _b : "range";
                    link.setAttribute("download", "ST_Reports_".concat(df, "_").concat(dt, ".csv"));
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    return [2 /*return*/, true];
            }
        });
    }); };
}
var updateKeysOfArray = function (inputArray) {
    if (!(inputArray === null || inputArray === void 0 ? void 0 : inputArray.length)) {
        return inputArray !== null && inputArray !== void 0 ? inputArray : [];
    }
    return inputArray.map(function (item) {
        return item ? __assign(__assign({}, item), { B2BCompanyName: item.b2BCompanyName, B2BLocationName: item.b2BLocationName }) : item;
    });
};
export function getCustomerAddress(customer_Id) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var addressData, AddressesListAndSingleShopifyCustomers, action;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, customerAddressDataService(customer_Id).then(function (data) { return data; })];
                case 1:
                    addressData = _a.sent();
                    AddressesListAndSingleShopifyCustomers = { customerAddressesList: addressData.customerAddressesList, SingleShopifyCustomers: addressData.SingleShopifyCustomers };
                    if (addressData) {
                        action = {
                            payload: AddressesListAndSingleShopifyCustomers,
                            type: SalesRepDataActionType.CUSTOMER_ADDRESS_DATA,
                        };
                        return [2 /*return*/, dispatch(action)];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
}
export function getProductsRender() {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var salesRepData, productData, ProductArray, action, action1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    salesRepData = store.getState().salesRepData;
                    if (!(((_a = salesRepData.productsData) === null || _a === void 0 ? void 0 : _a.length) !== 0)) return [3 /*break*/, 1];
                    return [2 /*return*/, salesRepData.productsData];
                case 1: return [4 /*yield*/, productRenderDataService().then(function (data) { return data.products; })];
                case 2:
                    productData = _c.sent();
                    ProductArray = productData === null || productData === void 0 ? void 0 : productData.filter(function (product) { var _a; return ((_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.length) > 0; });
                    action = {
                        payload: ProductArray,
                        type: SalesRepDataActionType.PRODUCTS_DATA,
                    };
                    dispatch(action);
                    action1 = {
                        payload: __assign(__assign({}, (_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.baseData), { completedGetProductApi: true }),
                        type: SalesRepDataActionType.BASE_DATA,
                    };
                    dispatch(action1);
                    return [2 /*return*/, true];
            }
        });
    }); };
}
export var createOrders = function (draftOrderData, isEditOrder) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0: return [4 /*yield*/, createDraftOrderService(draftOrderData, isEditOrder)];
            case 1:
                response = _k.sent();
                if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                    if (isEditOrder) {
                        // Server may return 200 with exceptionMessage, or 200 with updated/minimal body – treat 200 as order created/updated
                        if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.exceptionMessage) {
                            return [2 /*return*/, { exceptionMessage: response.data.exceptionMessage }];
                        }
                        return [2 /*return*/, true];
                    }
                    else {
                        if ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.exceptionMessage) {
                            return [2 /*return*/, { exceptionMessage: response.data.exceptionMessage }];
                        }
                        return [2 /*return*/, ((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.id) !== "" &&
                                ((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.id) !== undefined &&
                                ((_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.id) !== null &&
                                ((_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.invoice_url) !== "" &&
                                ((_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.invoice_url) !== undefined &&
                                ((_h = response === null || response === void 0 ? void 0 : response.data) === null || _h === void 0 ? void 0 : _h.invoice_url) !== null
                                ? (_j = response === null || response === void 0 ? void 0 : response.data) === null || _j === void 0 ? void 0 : _j.invoice_url
                                : ""];
                    }
                }
                else {
                    return [2 /*return*/, ""];
                }
                return [2 /*return*/];
        }
    });
}); };
export function getSalesRepCouponData() {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var viewCouponData, action;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(((_a = store.getState().salesRepData.viewCouponData) === null || _a === void 0 ? void 0 : _a.length) > 0)) return [3 /*break*/, 1];
                    return [2 /*return*/, store.getState().salesRepData.viewCouponData];
                case 1: return [4 /*yield*/, getViewCouponDataService().then(function (data) { return data; })];
                case 2:
                    viewCouponData = _b.sent();
                    if (viewCouponData.Coupons) {
                        action = {
                            payload: viewCouponData.Coupons,
                            type: SalesRepDataActionType.VIEW_COUPON_DATA,
                        };
                        return [2 /*return*/, dispatch(action)];
                    }
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
}
export function createCouponAction(params) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var newCoupon, action;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createCouponService(params).then(function (data) { return data; })];
                case 1:
                    newCoupon = _a.sent();
                    if (newCoupon === "Coupon Created") {
                        action = {
                            payload: [],
                            type: SalesRepDataActionType.VIEW_COUPON_DATA,
                        };
                        dispatch(action);
                    }
                    return [2 /*return*/, newCoupon];
            }
        });
    }); };
}
export function removeCouponAction(params) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var newCouponData, newViewCouponData, action;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, removeCouponService(params).then(function (data) { return data; })];
                case 1:
                    newCouponData = _a.sent();
                    if (newCouponData && store.getState().salesRepData.viewCouponData) {
                        newViewCouponData = store.getState().salesRepData.viewCouponData;
                        newViewCouponData === null || newViewCouponData === void 0 ? void 0 : newViewCouponData.forEach(function (item, index) {
                            if (params.couponid === item.couponId) {
                                newViewCouponData.splice(index, 1);
                            }
                        });
                        action = {
                            payload: newViewCouponData,
                            type: SalesRepDataActionType.VIEW_COUPON_DATA,
                        };
                        return [2 /*return*/, dispatch(action)];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
}
export function addCustomerData(params) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, addCustomerDataService(params).then(function (data) { return data; })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    }); };
}
export function singleCustomerData(params) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, singleCustomerDataService(params).then(function (data) { return data; })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    }); };
}
export function orderCountDetail(params) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, orderCountDetailsService(params).then(function (data) { return data; })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    }); };
}
export function orderWiseProductsData(params) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, orderWiseProductsDataService(params).then(function (data) { return data; })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    }); };
}
export function getDraftOrderData() {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var draftOrderResponse, action, action1, action;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!(((_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.draftOrderData) === null || _b === void 0 ? void 0 : _b.length) > 0)) return [3 /*break*/, 1];
                    return [2 /*return*/, store.getState().salesRepData.draftOrderData];
                case 1: return [4 /*yield*/, draftOrderDataService().then(function (data) { return data; })];
                case 2:
                    draftOrderResponse = _e.sent();
                    if (draftOrderResponse === null || draftOrderResponse === void 0 ? void 0 : draftOrderResponse.ClientInvoiceDetails) {
                        action = {
                            payload: draftOrderResponse.ClientInvoiceDetails,
                            type: SalesRepDataActionType.DRAFT_ORDER_DATA,
                        };
                        dispatch(action);
                        action1 = {
                            payload: __assign(__assign({}, (_c = store.getState().salesRepData) === null || _c === void 0 ? void 0 : _c.ordersData), { draftOrdersDetails: draftOrdersFilters(draftOrderResponse === null || draftOrderResponse === void 0 ? void 0 : draftOrderResponse.ClientInvoiceDetails), isDraftOrdersLoaded: true }),
                            type: SalesRepDataActionType.ORDERS_DATA,
                        };
                        dispatch(action1);
                        return [2 /*return*/, true];
                    }
                    else {
                        action = {
                            payload: __assign(__assign({}, (_d = store.getState().salesRepData) === null || _d === void 0 ? void 0 : _d.ordersData), { draftOrdersDetails: [], isDraftOrdersLoaded: false }),
                            type: SalesRepDataActionType.ORDERS_DATA,
                        };
                        dispatch(action);
                        return [2 /*return*/, []];
                    }
                    _e.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
}
var draftOrdersFilters = function (DraftOrders) {
    var draftOrders = [];
    DraftOrders === null || DraftOrders === void 0 ? void 0 : DraftOrders.filter(function (orderObj, index) {
        var _a, _b, _c;
        if ((orderObj === null || orderObj === void 0 ? void 0 : orderObj.status) && (((_a = orderObj === null || orderObj === void 0 ? void 0 : orderObj.status) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "open" || ((_b = orderObj === null || orderObj === void 0 ? void 0 : orderObj.status) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === "voided")) {
            var obj = {
                orderNumber: orderObj === null || orderObj === void 0 ? void 0 : orderObj.orderNumber,
                orderName: orderObj === null || orderObj === void 0 ? void 0 : orderObj.orderName,
                orderDate: orderObj === null || orderObj === void 0 ? void 0 : orderObj.orderDate,
                OrderPaidDate: orderObj === null || orderObj === void 0 ? void 0 : orderObj.orderPaidDate,
                CustomerName: orderObj === null || orderObj === void 0 ? void 0 : orderObj.customername,
                CustomerId: orderObj === null || orderObj === void 0 ? void 0 : orderObj.CustomerId,
                SalesRepName: null,
                SalesRepId: null,
                CustomerEmail: orderObj === null || orderObj === void 0 ? void 0 : orderObj.emailid,
                subtotal: orderObj === null || orderObj === void 0 ? void 0 : orderObj.subtotalprice,
                commission: 0,
                TeamManagerCommission: 0,
                CommissionType: "-",
                ProductTitle: "",
                OrderId: Number((_c = orderObj === null || orderObj === void 0 ? void 0 : orderObj.orderid) !== null && _c !== void 0 ? _c : 0),
                total: 0,
                financial_status: null,
                fulfillment_status: null,
                TypeOfCustomer: null,
                DateOfFirstOrder: null,
                PartyId: 0,
                Discount: 0,
                FulfillmentDate: "",
                OrderStatus: orderObj === null || orderObj === void 0 ? void 0 : orderObj.status,
                b2BCompanyId: null,
                B2BCompanyName: orderObj === null || orderObj === void 0 ? void 0 : orderObj.B2BCompanyName,
                b2BLocationId: null,
                B2BLocationName: orderObj === null || orderObj === void 0 ? void 0 : orderObj.B2BLocationName,
            };
            draftOrders.push(obj);
        }
    });
    return draftOrders;
};
var refundOrdersFilters = function (RefundOrders) {
    var refundOrders = [];
    RefundOrders === null || RefundOrders === void 0 ? void 0 : RefundOrders.filter(function (orderObj, index) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((orderObj === null || orderObj === void 0 ? void 0 : orderObj.OrderStatus) && (((_a = orderObj === null || orderObj === void 0 ? void 0 : orderObj.OrderStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "refunded" || ((_b = orderObj === null || orderObj === void 0 ? void 0 : orderObj.OrderStatus) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === "partially_refunded")) {
            var isHyphenFormat = (_c = orderObj === null || orderObj === void 0 ? void 0 : orderObj.OrderDate) === null || _c === void 0 ? void 0 : _c.includes("-");
            var dateString = isHyphenFormat
                ? (_d = orderObj === null || orderObj === void 0 ? void 0 : orderObj.OrderDate) === null || _d === void 0 ? void 0 : _d.split("T")[0].replace(/(\d{4})-(\d{2})-(\d{2}).*/, "$2/$3/$1")
                : new Date(parseInt((_e = orderObj === null || orderObj === void 0 ? void 0 : orderObj.OrderDate) === null || _e === void 0 ? void 0 : _e.replace("/Date(", "").replace(")/", ""))).toLocaleDateString();
            var obj = {
                orderNumber: orderObj === null || orderObj === void 0 ? void 0 : orderObj.ShopifyOrderNumber,
                orderName: orderObj === null || orderObj === void 0 ? void 0 : orderObj.OrderName,
                orderDate: dateString,
                OrderPaidDate: "-",
                CustomerName: "-",
                CustomerId: "-",
                SalesRepName: null,
                SalesRepId: orderObj === null || orderObj === void 0 ? void 0 : orderObj.SalesRepId,
                CustomerEmail: "-",
                subtotal: orderObj === null || orderObj === void 0 ? void 0 : orderObj.RefundSubTotal,
                commission: orderObj === null || orderObj === void 0 ? void 0 : orderObj.Commission,
                TeamManagerCommission: orderObj === null || orderObj === void 0 ? void 0 : orderObj.TeamManagerCommission,
                CommissionType: orderObj === null || orderObj === void 0 ? void 0 : orderObj.OrderType,
                ProductTitle: "",
                OrderId: Number((_f = orderObj === null || orderObj === void 0 ? void 0 : orderObj.orderId) !== null && _f !== void 0 ? _f : 0),
                total: 0,
                financial_status: null,
                fulfillment_status: null,
                TypeOfCustomer: null,
                DateOfFirstOrder: null,
                PartyId: 0,
                Discount: 0,
                FulfillmentDate: "",
                OrderStatus: orderObj === null || orderObj === void 0 ? void 0 : orderObj.OrderStatus,
                b2BCompanyId: null,
                B2BCompanyName: "-",
                b2BLocationId: null,
                B2BLocationName: "-",
                isRefundedOrders: true,
                RefundId: (_g = orderObj === null || orderObj === void 0 ? void 0 : orderObj.RefundId) !== null && _g !== void 0 ? _g : "",
                RefundApiOrderId: (_h = orderObj === null || orderObj === void 0 ? void 0 : orderObj.orderId) !== null && _h !== void 0 ? _h : "",
            };
            refundOrders.push(obj);
        }
    });
    return refundOrders;
};
export var deleteShareCartLink = function (deleteShareCartLinkData) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, sharedCartData, action;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, deleteShareCartLinkService(deleteShareCartLinkData)];
                case 1:
                    response = _a.sent();
                    if (response.data && store.getState().salesRepData.baseData.SharedCartDetails) {
                        sharedCartData = store.getState().salesRepData.baseData.SharedCartDetails;
                        sharedCartData === null || sharedCartData === void 0 ? void 0 : sharedCartData.forEach(function (SharedCart, index) {
                            if (index === void 0) { index = 0; }
                            if (SharedCart.CartUniqueId === deleteShareCartLinkData.cartUniqueId) {
                                sharedCartData.splice(index, 1);
                            }
                        });
                        action = {
                            payload: __assign(__assign({}, store.getState().salesRepData.baseData), { SharedCartDetails: sharedCartData }),
                            type: SalesRepDataActionType.BASE_DATA,
                        };
                        return [2 /*return*/, dispatch(action)];
                    }
                    else {
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
};
export function affiliateLinkConfirmationAction(affiliatePopUpVisible) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var isPopUpUpdated, currentPopUpStatus, updatedPopUpStatus, action;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0: return [4 /*yield*/, affiliateLinkConfirmationService(affiliatePopUpVisible)];
                case 1:
                    isPopUpUpdated = _f.sent();
                    if (isPopUpUpdated && ((_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.baseData) === null || _b === void 0 ? void 0 : _b.ConfirmationPopUpStatus)) {
                        currentPopUpStatus = (_d = (_c = store.getState().salesRepData) === null || _c === void 0 ? void 0 : _c.baseData) === null || _d === void 0 ? void 0 : _d.ConfirmationPopUpStatus;
                        updatedPopUpStatus = __assign(__assign({}, currentPopUpStatus), { isAffiliatePopUpVisible: true });
                        action = {
                            payload: __assign(__assign({}, (_e = store.getState().salesRepData) === null || _e === void 0 ? void 0 : _e.baseData), { ConfirmationPopUpStatus: updatedPopUpStatus }),
                            type: SalesRepDataActionType.BASE_DATA,
                        };
                        dispatch(action);
                        return [2 /*return*/, true];
                    }
                    else {
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
}
export function createCart(createCartData) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createCartService(createCartData).then(function (data) { return data; })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    }); };
}
export function draftOrderDetails(params, actionEvent) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var response, action;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, draftOrderDetailsService(params).then(function (data) { return data; })];
                case 1:
                    response = _c.sent();
                    if (response && (response === null || response === void 0 ? void 0 : response.draftOrder) && ((_a = Object.keys(response === null || response === void 0 ? void 0 : response.draftOrder)) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = response === null || response === void 0 ? void 0 : response.ProductDetails) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                        action = {
                            payload: { draftOrderObj: response === null || response === void 0 ? void 0 : response.draftOrder, productDetailsArray: response === null || response === void 0 ? void 0 : response.ProductDetails, actionEvent: actionEvent, isUpdatedCart: false },
                            type: SalesRepDataActionType.EDIT_DRAFT_ORDER,
                        };
                        dispatch(action);
                    }
                    return [2 /*return*/, response];
            }
        });
    }); };
}
export function duplicateOrderData(params, actionEvent) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var response, action;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, duplicateOrderService(params).then(function (data) { return data; })];
                case 1:
                    response = _c.sent();
                    if (response && (response === null || response === void 0 ? void 0 : response.draftOrder) && ((_a = Object.keys(response === null || response === void 0 ? void 0 : response.draftOrder)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        action = {
                            payload: {
                                draftOrderObj: response === null || response === void 0 ? void 0 : response.draftOrder,
                                productDetailsArray: (_b = response === null || response === void 0 ? void 0 : response.ProductDetails) !== null && _b !== void 0 ? _b : [],
                                actionEvent: actionEvent,
                                isUpdatedCart: false,
                                isDuplicate: true,
                            },
                            type: SalesRepDataActionType.EDIT_DRAFT_ORDER,
                        };
                        dispatch(action);
                    }
                    return [2 /*return*/, response];
            }
        });
    }); };
}
export function sendInvoiceData(params) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, sendInvoiceDataService(params).then(function (data) { return data; })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    }); };
}
export function deleteInvoiceData(params) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var responseData, paramsStr, newdraftOrderData, draftOrderAction, currentOrdersData, updatedDraftOrdersDetails, ordersDataAction;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, deleteInvoiceService(params).then(function (data) { return data; })];
                case 1:
                    responseData = _b.sent();
                    paramsStr = String(params);
                    if (responseData && responseData !== false) {
                        // Update draftOrderData if it exists
                        if (store.getState().salesRepData.draftOrderData) {
                            newdraftOrderData = store.getState().salesRepData.draftOrderData;
                            newdraftOrderData === null || newdraftOrderData === void 0 ? void 0 : newdraftOrderData.forEach(function (item, index) {
                                if (String(item.orderid) === paramsStr) {
                                    newdraftOrderData.splice(index, 1);
                                }
                            });
                            draftOrderAction = {
                                payload: newdraftOrderData,
                                type: SalesRepDataActionType.DRAFT_ORDER_DATA,
                            };
                            dispatch(draftOrderAction);
                        }
                        currentOrdersData = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.ordersData;
                        if (currentOrdersData === null || currentOrdersData === void 0 ? void 0 : currentOrdersData.draftOrdersDetails) {
                            updatedDraftOrdersDetails = currentOrdersData.draftOrdersDetails.filter(function (order) { return String(order.OrderId) !== paramsStr; });
                            ordersDataAction = {
                                payload: __assign(__assign({}, currentOrdersData), { draftOrdersDetails: updatedDraftOrdersDetails }),
                                type: SalesRepDataActionType.ORDERS_DATA,
                            };
                            dispatch(ordersDataAction);
                        }
                    }
                    return [2 /*return*/, responseData];
            }
        });
    }); };
}
export function refundOrderData(params) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, refundOrderDataService(params).then(function (data) { return data; })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    }); };
}
export function updateAffiliateLinkAction(data) {
    return __awaiter(this, void 0, void 0, function () {
        var isLinkUpdated;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, uploadAffiliateLinkData(data)];
                case 1:
                    isLinkUpdated = _a.sent();
                    return [2 /*return*/, isLinkUpdated];
            }
        });
    });
}
export function uploadAffiliatePhotoAction(file) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var isPhotoUpdated, salesRepData, updateProfileImagePath, action, updateProfileImagePath, action;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, uploadAffiliatePhoto(file)
                        .then(function (response) {
                        return response;
                    })
                        .catch(function (error) { return error; })];
                case 1:
                    isPhotoUpdated = _d.sent();
                    if (!isPhotoUpdated) return [3 /*break*/, 3];
                    return [4 /*yield*/, salesRepBaseDataService().then(function (data) { return data; })];
                case 2:
                    salesRepData = _d.sent();
                    updateProfileImagePath = (_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.SingleSalesRep) === null || _a === void 0 ? void 0 : _a.ProfileImagePath;
                    if (updateProfileImagePath) {
                        action = {
                            payload: updateProfileImagePath,
                            type: SalesRepDataActionType.UPDATE_REP_PROFILE,
                        };
                        dispatch(action);
                        return [2 /*return*/, true];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    updateProfileImagePath = (_c = (_b = store.getState().salesRepData.baseData) === null || _b === void 0 ? void 0 : _b.SingleSalesRep) === null || _c === void 0 ? void 0 : _c.ProfileImagePath;
                    action = {
                        payload: updateProfileImagePath,
                        type: SalesRepDataActionType.UPDATE_REP_PROFILE,
                    };
                    dispatch(action);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
export function GetAllWholesalePrices() {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var priceListData, action;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetAllWholesalePriceService().then(function (data) { return data; })];
                case 1:
                    priceListData = _a.sent();
                    if (priceListData) {
                        action = {
                            payload: priceListData,
                            type: SalesRepDataActionType.WHOLESALE_PRICE_DATA,
                        };
                        return [2 /*return*/, dispatch(action)];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
}
export function submitSignupRepDetails(signupRepDetails) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var userDetailsResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, submitSignupRepDetailsService(signupRepDetails).then(function (data) { return data; })];
                case 1:
                    userDetailsResponse = _a.sent();
                    return [2 /*return*/, userDetailsResponse];
            }
        });
    }); };
}
export function userLoginAction(userDetails) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var userResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userLoginService(userDetails).then(function (data) { return data; })];
                case 1:
                    userResponse = _a.sent();
                    return [2 /*return*/, userResponse];
            }
        });
    }); };
}
export function resetPasswordAction(email) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var forgotPasswordResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, forgotPasswordService(email).then(function (data) { return data; })];
                case 1:
                    forgotPasswordResponse = _a.sent();
                    return [2 /*return*/, forgotPasswordResponse];
            }
        });
    }); };
}
export function dataAddingOnCart(parameter, Type) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var responseMsg;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, DataAddOnCart(parameter, Type)];
                case 1:
                    responseMsg = _d.sent();
                    if (typeof responseMsg === "boolean" && responseMsg === true) {
                        return [2 /*return*/, responseMsg];
                    }
                    else {
                        return [2 /*return*/, (_c = (_b = (_a = responseMsg === null || responseMsg === void 0 ? void 0 : responseMsg.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.description) !== null && _c !== void 0 ? _c : responseMsg === null || responseMsg === void 0 ? void 0 : responseMsg.message];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
}
export function updatePasswordAction(passwordObject) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var responseMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updatePasswordService(passwordObject)];
                case 1:
                    responseMsg = _a.sent();
                    return [2 /*return*/, responseMsg];
            }
        });
    }); };
}
export function gettingCartData() {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var responseGetCart;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetCartData()];
                case 1:
                    responseGetCart = _a.sent();
                    return [2 /*return*/, responseGetCart];
            }
        });
    }); };
}
export function GetCompanyLocationPricelist(companyLocationID, objectToPass, isSearchProduct, isProductLoaded) {
    var _this = this;
    if (isSearchProduct === void 0) { isSearchProduct = false; }
    if (isProductLoaded === void 0) { isProductLoaded = false; }
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var reduxLocationPricelistData, serviceResponse, locationData, updatedLocationPricelistData, action, error_4;
        var _a;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 6, , 7]);
                    reduxLocationPricelistData = store.getState().salesRepData.locationPricelistData || {};
                    // Prevent redundant API calls if:
                    // 1. Not a search product call (search calls should always fetch fresh data)
                    // 2. Location data already exists in Redux with a non-empty priceList
                    if (!isSearchProduct &&
                        reduxLocationPricelistData[companyLocationID] &&
                        ((_b = reduxLocationPricelistData[companyLocationID]) === null || _b === void 0 ? void 0 : _b.priceList) &&
                        Object.keys(reduxLocationPricelistData[companyLocationID].priceList).length > 0) {
                        return [2 /*return*/, reduxLocationPricelistData[companyLocationID]];
                    }
                    if (!companyLocationID) return [3 /*break*/, 5];
                    serviceResponse = void 0;
                    if (!isSearchProduct) return [3 /*break*/, 2];
                    return [4 /*yield*/, GetCompanyLocationSearchedPricelistService(companyLocationID, objectToPass)];
                case 1:
                    serviceResponse = _d.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, GetCompanyLocationPricelistService(companyLocationID, objectToPass)];
                case 3:
                    serviceResponse = _d.sent();
                    _d.label = 4;
                case 4:
                    if (serviceResponse) {
                        locationData = __assign({ priceList: __assign({}, serviceResponse === null || serviceResponse === void 0 ? void 0 : serviceResponse.b2bPriceList), companyLocationCatalogCursorDetails: __assign({}, serviceResponse === null || serviceResponse === void 0 ? void 0 : serviceResponse.companyLocationCatalogCursorDetails) }, serviceResponse === null || serviceResponse === void 0 ? void 0 : serviceResponse.selectedB2bLocationDetails);
                        updatedLocationPricelistData = __assign(__assign({}, reduxLocationPricelistData), (_a = {}, _a[companyLocationID] = __assign(__assign(__assign({}, reduxLocationPricelistData[companyLocationID]), { priceList: __assign(__assign({}, (_c = reduxLocationPricelistData[companyLocationID]) === null || _c === void 0 ? void 0 : _c.priceList), locationData.priceList), companyLocationCatalogCursorDetails: locationData.companyLocationCatalogCursorDetails }), locationData), _a));
                        action = {
                            payload: updatedLocationPricelistData,
                            type: SalesRepDataActionType.LOCATION_PRICELIST_DATA,
                        };
                        dispatch(action);
                        return [2 /*return*/, updatedLocationPricelistData[companyLocationID]]; // Return updated data for the specific location
                    }
                    _d.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_4 = _d.sent();
                    return [2 /*return*/, null];
                case 7: return [2 /*return*/];
            }
        });
    }); };
}
export function GetCompanyLocationQuantityRule(companyLocationID, dictToPass) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var reduxLocationPricelistData, serviceResponse_1, priceList_1, updatedLocationPricelistData, action, error_5;
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    reduxLocationPricelistData = store.getState().salesRepData.locationPricelistData || {};
                    return [4 /*yield*/, GetCompanyLocationQuantityRuleService(dictToPass)];
                case 1:
                    serviceResponse_1 = _c.sent();
                    priceList_1 = ((_b = reduxLocationPricelistData[companyLocationID]) === null || _b === void 0 ? void 0 : _b.priceList) || [];
                    if (serviceResponse_1) {
                        // Iterate through priceList and update QuantityRule for matching variantId
                        priceList_1 = Object.keys(priceList_1).reduce(function (acc, variantId) {
                            var _a;
                            var priceItem = priceList_1[variantId]; // Get the price item
                            if (variantId && ((_a = serviceResponse_1 === null || serviceResponse_1 === void 0 ? void 0 : serviceResponse_1.CatalogQuantityRulesDetails) === null || _a === void 0 ? void 0 : _a[variantId])) {
                                acc[variantId] = __assign(__assign({}, priceItem), { QuantityRule: serviceResponse_1.CatalogQuantityRulesDetails[variantId] });
                            }
                            else {
                                acc[variantId] = priceItem; // Keep unchanged
                            }
                            return acc;
                        }, {});
                        updatedLocationPricelistData = __assign(__assign({}, reduxLocationPricelistData), (_a = {}, _a[companyLocationID] = __assign(__assign({}, reduxLocationPricelistData[companyLocationID]), { priceList: priceList_1 }), _a));
                        action = {
                            payload: updatedLocationPricelistData,
                            type: SalesRepDataActionType.LOCATION_PRICELIST_DATA,
                        };
                        dispatch(action);
                        return [2 /*return*/, updatedLocationPricelistData[companyLocationID]]; // Return updated data for this location
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_5 = _c.sent();
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
}
export var createB2BOrder = function (draftOrderData) { return __awaiter(void 0, void 0, void 0, function () {
    var response, invoiceUrl, orderId, error_6;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, createB2bDraftOrderService(draftOrderData)];
            case 1:
                response = _b.sent();
                invoiceUrl = response === null || response === void 0 ? void 0 : response.invoice_url;
                orderId = response === null || response === void 0 ? void 0 : response.id;
                if (orderId && invoiceUrl) {
                    return [2 /*return*/, invoiceUrl];
                }
                return [2 /*return*/, (_a = response === null || response === void 0 ? void 0 : response.exceptionMessage) !== null && _a !== void 0 ? _a : ""];
            case 2:
                error_6 = _b.sent();
                return [2 /*return*/, "Failed to create company orders."];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var updateB2BOrder = function (draftOrderData, orderId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, invoiceUrl, updatedOrderId, error_7;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, updateB2bDraftOrderService(draftOrderData, orderId)];
            case 1:
                response = _b.sent();
                invoiceUrl = response === null || response === void 0 ? void 0 : response.invoice_url;
                updatedOrderId = response === null || response === void 0 ? void 0 : response.id;
                if (updatedOrderId && invoiceUrl) {
                    return [2 /*return*/, invoiceUrl];
                }
                return [2 /*return*/, (_a = response === null || response === void 0 ? void 0 : response.exceptionMessage) !== null && _a !== void 0 ? _a : ""];
            case 2:
                error_7 = _b.sent();
                return [2 /*return*/, "Failed to update company orders."];
            case 3: return [2 /*return*/];
        }
    });
}); };
export function singleCompanyDataService(resourceNo, id) {
    var _this = this;
    try {
        return function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, B2BCreateCompanyGetService(resourceNo, id).then(function (data) { return data; })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        }); };
    }
    catch (_a) {
        return null;
    }
}
export function getCustomerListWithMainContact(resourceNo, fromCreateCustomer) {
    var _this = this;
    if (fromCreateCustomer === void 0) { fromCreateCustomer = false; }
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var stateData, addressData, customerList, action, _a;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 4, , 5]);
                    stateData = (_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.customerListWithMainContact;
                    if (!(stateData && (stateData === null || stateData === void 0 ? void 0 : stateData.length) > 0 && !fromCreateCustomer)) return [3 /*break*/, 1];
                    return [2 /*return*/, (_c = store.getState().salesRepData) === null || _c === void 0 ? void 0 : _c.customerListWithMainContact];
                case 1: return [4 /*yield*/, B2BCreateCompanyGetService(resourceNo).then(function (data) { return data; })];
                case 2:
                    addressData = _d.sent();
                    customerList = addressData === null || addressData === void 0 ? void 0 : addressData.ClientOrders;
                    if (addressData) {
                        action = {
                            payload: customerList,
                            type: SalesRepDataActionType.CUSTOMER_LIST_WITH_MAINCONTACT,
                        };
                        return [2 /*return*/, dispatch(action)];
                    }
                    _d.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    _a = _d.sent();
                    return [2 /*return*/, null];
                case 5: return [2 /*return*/];
            }
        });
    }); };
}
export function getCatalogListWithProductCount(resourceNo) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var stateData, catalogsData, catalogList, action, _a;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 4, , 5]);
                    stateData = (_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.catalogProductList;
                    if (!(stateData && (stateData === null || stateData === void 0 ? void 0 : stateData.length) > 0)) return [3 /*break*/, 1];
                    return [2 /*return*/, (_c = store.getState().salesRepData) === null || _c === void 0 ? void 0 : _c.catalogProductList];
                case 1: return [4 /*yield*/, B2BCreateCompanyGetService(resourceNo).then(function (data) { return data; })];
                case 2:
                    catalogsData = _d.sent();
                    catalogList = catalogsData === null || catalogsData === void 0 ? void 0 : catalogsData.shopCatalogList;
                    if (catalogsData) {
                        action = {
                            payload: catalogList,
                            type: SalesRepDataActionType === null || SalesRepDataActionType === void 0 ? void 0 : SalesRepDataActionType.CATALOG_PRODUCT_LIST,
                        };
                        return [2 /*return*/, dispatch(action)];
                    }
                    _d.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    _a = _d.sent();
                    return [2 /*return*/, null];
                case 5: return [2 /*return*/];
            }
        });
    }); };
}
// create new company
export function createCompanyAction(companyDetails, resourceNo) {
    return __awaiter(this, void 0, void 0, function () {
        var response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, B2BCreateUpdateCompanyPostService(companyDetails, resourceNo)];
                case 1:
                    response = _b.sent();
                    if ((response === null || response === void 0 ? void 0 : response.success) && (response === null || response === void 0 ? void 0 : response.company)) {
                        return [2 /*return*/, true];
                    }
                    else {
                        return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.errorMessage) || "Failed to create company."];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    return [2 /*return*/, "Failed to create company."];
                case 3: return [2 /*return*/];
            }
        });
    });
}
// Company list for B2B is loaded via data=56 into local component state (My Company, B2B popup), not persisted in baseData.
// Customer flow uses getAllCustomersAction + optional REP_ALL_CUSTOMERS; we do not mirror company lists into BASE_DATA.
// After resource 6 (address) the server refreshes cache; UI refreshes list via data=56 where needed (see My Company refreshCompanyList).
export function updateCompanyLocationAction(B2BCompanyDetails, resourceNo) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, B2BCreateUpdateCompanyPostService(B2BCompanyDetails, resourceNo)];
                case 1:
                    response = _b.sent();
                    if (response.success) {
                        return [2 /*return*/, true];
                    }
                    else {
                        return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.errorMessage) || "Failed to update company location."];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    return [2 /*return*/, "Failed to update company location."];
                case 3: return [2 /*return*/];
            }
        });
    }); };
}
// create new company location
export function createCompanyLocationAction(companyLocationDetails, resourceNo) {
    return __awaiter(this, void 0, void 0, function () {
        var response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, B2BCreateUpdateCompanyPostService(companyLocationDetails, resourceNo)];
                case 1:
                    response = _b.sent();
                    if (response === null || response === void 0 ? void 0 : response.success) {
                        return [2 /*return*/, true];
                    }
                    else {
                        return [2 /*return*/, response.errorMessage || "Failed to create company location."];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    return [2 /*return*/, "Failed to create company location."];
                case 3: return [2 /*return*/];
            }
        });
    });
}
// update company notes
export function updateCompanyNoteAction(companyDetailsPayload, resourceNo) {
    return __awaiter(this, void 0, void 0, function () {
        var response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, B2BCreateUpdateCompanyPostService(companyDetailsPayload, resourceNo)];
                case 1:
                    response = _b.sent();
                    if (response === null || response === void 0 ? void 0 : response.success) {
                        return [2 /*return*/, true];
                    }
                    else {
                        return [2 /*return*/, response.errorMessage || "Failed to update company note."];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    return [2 /*return*/, "Failed to update company note."];
                case 3: return [2 /*return*/];
            }
        });
    });
}
//Remove Image Action removeProfileAndContactCardImageAction
export function removeProfileImageAction() {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var photoRemoved, currentRep, updatedRep, action, error_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, removeProfileImageService()];
                case 1:
                    photoRemoved = _a.sent();
                    if (photoRemoved) {
                        currentRep = store.getState().salesRepData.baseData.SingleSalesRep;
                        updatedRep = __assign(__assign({}, currentRep), { ProfileImagePath: "" });
                        action = {
                            payload: updatedRep,
                            type: SalesRepDataActionType.UPDATE_SINGLE_SALES_REP,
                        };
                        dispatch(action);
                    }
                    return [2 /*return*/, photoRemoved];
                case 2:
                    error_8 = _a.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
}
export function getAllCustomersAction(params) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var response, customerDetails, customers, mappedCustomers, result, _a;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getAllCustomersService(params)];
                case 1:
                    response = _f.sent();
                    customerDetails = response === null || response === void 0 ? void 0 : response.GetCustomerDetails;
                    customers = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.Customers;
                    if (Array === null || Array === void 0 ? void 0 : Array.isArray(customers)) {
                        mappedCustomers = customers.map(function (customer) {
                            var _a, _b, _c, _d, _e, _f;
                            return ({
                                customerId: (_a = customer === null || customer === void 0 ? void 0 : customer.Id) !== null && _a !== void 0 ? _a : "",
                                firstName: (_b = customer === null || customer === void 0 ? void 0 : customer.FirstName) !== null && _b !== void 0 ? _b : "",
                                lastName: (_c = customer === null || customer === void 0 ? void 0 : customer.LastName) !== null && _c !== void 0 ? _c : "",
                                companyName: (_d = customer === null || customer === void 0 ? void 0 : customer.CompanyName) !== null && _d !== void 0 ? _d : "",
                                orderCount: (_e = customer === null || customer === void 0 ? void 0 : customer.OrderCount) !== null && _e !== void 0 ? _e : 0,
                                emailId: (_f = customer === null || customer === void 0 ? void 0 : customer.EmailId) !== null && _f !== void 0 ? _f : "",
                            });
                        });
                        result = {
                            customers: mappedCustomers,
                            endCursor: (_b = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.EndCursor) !== null && _b !== void 0 ? _b : "",
                            startCursor: (_c = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.StartCursor) !== null && _c !== void 0 ? _c : "",
                            hasPrevious: (_d = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.HasPrevious) !== null && _d !== void 0 ? _d : false,
                            hasNext: (_e = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.HasNext) !== null && _e !== void 0 ? _e : true,
                        };
                        if (params === null || params === void 0 ? void 0 : params.isSaveToStore) {
                            dispatch({
                                payload: result,
                                type: SalesRepDataActionType.REP_ALL_CUSTOMERS,
                            });
                        }
                        return [2 /*return*/, result];
                    }
                    return [2 /*return*/, null];
                case 2:
                    _a = _f.sent();
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
}
export function getB2BCompaniesAction(params) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var response, companyData, companies, result, isFirstPageRequest, isNonSearchRequest, _a;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    _l.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getB2BCompaniesService(params)];
                case 1:
                    response = _l.sent();
                    companyData = response === null || response === void 0 ? void 0 : response.GetB2BCompanyDetails;
                    companies = companyData === null || companyData === void 0 ? void 0 : companyData.Companies;
                    if (Array.isArray(companies)) {
                        result = {
                            companies: companies,
                            endCursor: (_b = companyData === null || companyData === void 0 ? void 0 : companyData.EndCursor) !== null && _b !== void 0 ? _b : "",
                            startCursor: (_c = companyData === null || companyData === void 0 ? void 0 : companyData.StartCursor) !== null && _c !== void 0 ? _c : "",
                            hasNext: (_d = companyData === null || companyData === void 0 ? void 0 : companyData.HasNext) !== null && _d !== void 0 ? _d : false,
                            hasPrevious: (_e = companyData === null || companyData === void 0 ? void 0 : companyData.HasPrevious) !== null && _e !== void 0 ? _e : false,
                            searchQuery: (_f = params.searchQuery) !== null && _f !== void 0 ? _f : "",
                        };
                        isFirstPageRequest = ((_g = params.isNextPage) !== null && _g !== void 0 ? _g : true) && !((_h = params.endCursor) !== null && _h !== void 0 ? _h : "") && !((_j = params.startCursor) !== null && _j !== void 0 ? _j : "");
                        isNonSearchRequest = !((_k = params.searchQuery) !== null && _k !== void 0 ? _k : "").trim();
                        if ((params === null || params === void 0 ? void 0 : params.isSaveToStore) && isFirstPageRequest && isNonSearchRequest) {
                            dispatch({
                                payload: result,
                                type: SalesRepDataActionType.B2B_COMPANIES_DATA,
                            });
                        }
                        return [2 /*return*/, result];
                    }
                    return [2 /*return*/, null];
                case 2:
                    _a = _l.sent();
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
}
export function getB2BCompanyByIdAction(params) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var response, companyData, companies, _a;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getB2BCompanyByIdService(params)];
                case 1:
                    response = _f.sent();
                    companyData = response === null || response === void 0 ? void 0 : response.GetB2BCompanyDetails;
                    companies = companyData === null || companyData === void 0 ? void 0 : companyData.Companies;
                    if (Array.isArray(companies)) {
                        return [2 /*return*/, {
                                companies: companies,
                                endCursor: (_b = companyData === null || companyData === void 0 ? void 0 : companyData.EndCursor) !== null && _b !== void 0 ? _b : "",
                                startCursor: (_c = companyData === null || companyData === void 0 ? void 0 : companyData.StartCursor) !== null && _c !== void 0 ? _c : "",
                                hasNext: (_d = companyData === null || companyData === void 0 ? void 0 : companyData.HasNext) !== null && _d !== void 0 ? _d : false,
                                hasPrevious: (_e = companyData === null || companyData === void 0 ? void 0 : companyData.HasPrevious) !== null && _e !== void 0 ? _e : false,
                                searchQuery: "",
                            }];
                    }
                    return [2 /*return*/, null];
                case 2:
                    _a = _f.sent();
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
}
